"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIssueSnapshotFlow = void 0;
var _react = require("react");
var _useCaptureSnapshot = require("./useCaptureSnapshot");
var _useUploadSnapshot = require("./useUploadSnapshot");
var _useSetSnapshotAsAThumbnail = require("./useSetSnapshotAsAThumbnail");
var _issueSnapshots = require("../../../../state/redux/ducks/issueSnapshots");
var _hooks = require("../../../../state/redux/hooks");
var _useSnapshotAbortController = require("./useSnapshotAbortController");
const useIssueSnapshotFlow = () => {
  const captureSnapshot = (0, _useCaptureSnapshot.useCaptureSnapshot)();
  const uploadSnapshot = (0, _useUploadSnapshot.useUploadSnapshot)();
  const setSnapshotAsAThumbnail = (0, _useSetSnapshotAsAThumbnail.useSetSnapshotAsAThumbnail)();
  const {
    getFlowId,
    abortAllFlows
  } = (0, _useSnapshotAbortController.useSnapshotAbortController)();
  const getIsIssueSnapshotInProgress = (0, _hooks.useSelector)(_issueSnapshots.getIsPersistingIssueSnapshot);
  const captureAndUploadSnapshot = (0, _react.useCallback)(async _ref => {
    let {
      issue
    } = _ref;
    if (getIsIssueSnapshotInProgress(issue.id)) {
      abortAllFlows(issue.id);
    }
    const flowId = getFlowId(issue.id);
    const snapshotBlob = await captureSnapshot({
      issue,
      flowId
    });
    const storageUrn = await uploadSnapshot({
      issue,
      snapshotBlob,
      hasMarkups: false,
      flowId
    });
    return {
      storageUrn,
      flowId
    };
  }, [getIsIssueSnapshotInProgress, getFlowId, captureSnapshot, abortAllFlows, uploadSnapshot]);
  const uploadSnapshotAsAThumbnail = (0, _react.useCallback)(async _ref2 => {
    let {
      issue,
      snapshotBlob,
      hasMarkups,
      trigger,
      flowId: flowIdFromProps
    } = _ref2;
    if (!flowIdFromProps && getIsIssueSnapshotInProgress(issue.id)) {
      abortAllFlows(issue.id);
    }
    const flowId = flowIdFromProps !== null && flowIdFromProps !== void 0 ? flowIdFromProps : getFlowId(issue.id);
    const storageUrn = await uploadSnapshot({
      issue,
      snapshotBlob,
      hasMarkups,
      flowId
    });
    await setSnapshotAsAThumbnail({
      issue,
      storageUrn,
      hasMarkups,
      trigger,
      flowId
    });
  }, [getIsIssueSnapshotInProgress, getFlowId, uploadSnapshot, setSnapshotAsAThumbnail, abortAllFlows]);
  const captureSnapshotAsAThumbnail = (0, _react.useCallback)(async _ref3 => {
    let {
      issue,
      hasMarkups,
      trigger
    } = _ref3;
    if (getIsIssueSnapshotInProgress(issue.id)) {
      abortAllFlows(issue.id);
    }
    const flowId = getFlowId(issue.id);
    const snapshotBlob = await captureSnapshot({
      issue,
      flowId
    });
    if (snapshotBlob) {
      await uploadSnapshotAsAThumbnail({
        issue,
        snapshotBlob,
        hasMarkups,
        trigger,
        flowId
      });
    }
  }, [getIsIssueSnapshotInProgress, getFlowId, captureSnapshot, abortAllFlows, uploadSnapshotAsAThumbnail]);
  return {
    captureSnapshot,
    uploadSnapshotAsAThumbnail,
    captureSnapshotAsAThumbnail,
    captureAndUploadSnapshot,
    uploadSnapshot,
    setSnapshotAsAThumbnail
  };
};
exports.useIssueSnapshotFlow = useIssueSnapshotFlow;
//# sourceMappingURL=index.js.map